var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"panel-promo",attrs:{"href":_vm.promo.url}},[_c('i',{class:_vm.promo.icon}),_c('span',{staticClass:"excerpt"},[_vm._v(_vm._s(_vm.promo.excerpt))]),_c('i',{staticClass:"far fa-arrow-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }